import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import QuarantinedMessageAlert from '../../../common-message/QuarantinedMessageAlert';
import { truncateString } from '../../../util/truncateString';
import MessagePreviewAttachments from './MessagePreviewAttachments';
import { getLocalDeepLinkUrlFromPathName } from '../../../url/getDeepLinkUrl';
import { useHistory, useLocation } from 'react-router-dom';
import { View } from 'foundations-components/components/View';
import styled from 'foundations-theming/utils';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AttachmentIconWrapper = styled.span.withConfig({
  displayName: "MessagePreview__AttachmentIconWrapper",
  componentId: "sc-1ps3swi-0"
})(({
  theme
}) => {
  return {
    'margin-inline-end': `${theme.space['100']}`
  };
});
const MessagePreview = props => {
  const {
    isLoading,
    isPreviewable
  } = props;
  const history = useHistory();
  const location = useLocation();
  if (isLoading) {
    return /*#__PURE__*/_jsxs(View, {
      padding: "200",
      borderRadius: "200",
      borderInlineStartWidth: "0",
      cursor: "default",
      backgroundColor: "fill-tertiary-default",
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockEnd: "100",
        children: /*#__PURE__*/_jsx(SkeletonText, {
          "data-test-id": "skeleton-text",
          inlineSize: "60px",
          blockSize: "15px"
        })
      }), /*#__PURE__*/_jsx(SkeletonText, {
        "data-test-id": "skeleton-text",
        inlineSize: "150px",
        blockSize: "15px"
      })]
    });
  }
  if (!isPreviewable) {
    return /*#__PURE__*/_jsx(View, {
      padding: "200",
      borderRadius: "200",
      borderInlineStartWidth: "0",
      cursor: "default",
      backgroundColor: "fill-tertiary-default",
      children: /*#__PURE__*/_jsx(Alert, {
        type: "warning",
        minBlockSize: "36px",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-message-history.message-preview.unavailable"
        })
      })
    });
  }
  const {
    attachmentPreview,
    isQuarantined,
    maxPreviewLength,
    messageText,
    senderName,
    messageId
  } = props;
  if (isQuarantined) {
    return /*#__PURE__*/_jsxs(View, {
      padding: "200",
      borderRadius: "200",
      borderInlineStartWidth: "0",
      cursor: "default",
      backgroundColor: "fill-tertiary-default",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-25",
        children: senderName
      }), /*#__PURE__*/_jsx(QuarantinedMessageAlert, {
        shouldRenderPreviewAlert: true
      })]
    });
  }
  const {
    hasMissingAttachment,
    Icon: AttachmentIcon,
    name: attachmentName,
    type: attachmentType
  } = attachmentPreview;
  const previewText = messageText && maxPreviewLength ? truncateString(messageText, maxPreviewLength) : messageText || attachmentName || attachmentType;
  return /*#__PURE__*/_jsxs(Flex, {
    justifyContent: 'space-between',
    padding: "200",
    paddingInline: "400",
    borderRadius: "100",
    backgroundColor: "fill-field-default",
    children: [/*#__PURE__*/_jsxs(View, {
      flexGrow: 1,
      overflow: "hidden",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-25",
        color: "text-core-subtle",
        children: senderName
      }), /*#__PURE__*/_jsxs(Text, {
        typography: "detail-200",
        color: "text-core-subtle",
        children: [AttachmentIcon && /*#__PURE__*/_jsx(AttachmentIconWrapper, {
          children: /*#__PURE__*/_jsx(AttachmentIcon, {})
        }), previewText ? /*#__PURE__*/_jsx("span", {
          children: previewText
        }) : hasMissingAttachment && /*#__PURE__*/_jsx("i", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.attachments.unavailableAttachment"
          })
        })]
      }), /*#__PURE__*/_jsx(Text, {
        typography: "detail-200",
        children: /*#__PURE__*/_jsx(Link, {
          href: getLocalDeepLinkUrlFromPathName(location, messageId),
          onClick: evt => {
            //stop navigation and prevent other onClick functions
            evt.preventDefault();
            evt.stopPropagation();
            const searchParams = new URLSearchParams(location.search);
            searchParams.set('messageId', messageId);
            history.replace({
              search: searchParams.toString()
            });
          },
          "data-test-id": 'message-preview-link',
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.message-preview.viewMessage"
          })
        })
      })]
    }), /*#__PURE__*/_jsx(MessagePreview.Attachments, Object.assign({}, attachmentPreview))]
  });
};
MessagePreview.Attachments = MessagePreviewAttachments;
MessagePreview.displayName = 'MessagePreview';
export default /*#__PURE__*/memo(MessagePreview);